function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "locked-square",
  transform: "translate(19)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_1758",
  "data-name": "Rectangle 1758",
  transform: "translate(-19)",
  fill: "none",
  stroke: "#727272",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 3.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "locked-markets",
  transform: "translate(-318.9 -76.992)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_542",
  "data-name": "Group 542",
  transform: "translate(308.872 82.799)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_859",
  "data-name": "Path 859",
  d: "M309.856,87.54h-.58c0-.01,0-1.039.069-1.961a2.978,2.978,0,0,1,2.994-2.78,2.907,2.907,0,0,1,2.995,2.8v1.812h-.58V85.6a2.327,2.327,0,0,0-2.415-2.222,2.4,2.4,0,0,0-2.415,2.243C309.857,86.522,309.856,87.53,309.856,87.54Z",
  transform: "translate(-309.276 -82.799)",
  fill: "#727272"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_543",
  "data-name": "Group 543",
  transform: "translate(307.93 87.335)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_860",
  "data-name": "Path 860",
  d: "M315.146,95.94h-6.491a.726.726,0,0,1-.725-.725V90.008a.726.726,0,0,1,.725-.725h6.491a.727.727,0,0,1,.725.725v5.207A.726.726,0,0,1,315.146,95.94Zm-6.491-6.077a.145.145,0,0,0-.145.145v5.207a.145.145,0,0,0,.145.145h6.491a.145.145,0,0,0,.145-.145V90.008a.145.145,0,0,0-.145-.145Z",
  transform: "translate(-307.93 -89.283)",
  fill: "#727272"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_544",
  "data-name": "Group 544",
  transform: "translate(310.562 89.218)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_861",
  "data-name": "Path 861",
  d: "M313.009,94.61a1.317,1.317,0,1,1,1.317-1.317A1.319,1.319,0,0,1,313.009,94.61Zm0-2.055a.737.737,0,1,0,.737.737A.738.738,0,0,0,313.009,92.555Z",
  transform: "translate(-311.692 -91.975)",
  fill: "#727272"
}))));

function SvgLockedSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedSquare);
export default __webpack_public_path__ + "static/media/locked-square.4d392d5d.svg";
export { ForwardRef as ReactComponent };